import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private readonly localStorageKey = 'selectedMenu';

  private selectedMenuSubject = new BehaviorSubject<string>(sessionStorage.getItem(this.localStorageKey) || 'ESIC Cards');
  selectedMenu$ = this.selectedMenuSubject.asObservable();

  setSelectedMenu(menu: string) {
    this.selectedMenuSubject.next(menu);
    sessionStorage.setItem(this.localStorageKey, menu);
  }
  getSelectedMenu() {
    return this.selectedMenuSubject;
  }
}
